import createComponentSchema from '../util/createComponentSchema'
import { z } from 'zod/v4'

const HeroBannerSecondarySchema = createComponentSchema(
  'HeroBannerSecondary',
  z.object({
    des: z.string(),
    complement: z.string(),
    leftBackgroundImageUrl: z.string().optional(),
    rightBackgroundImageUrl: z.string().optional(),
    anchorIdentifier: z.string().optional()
  })
)

export default HeroBannerSecondarySchema
